import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../i18n/translateAnimalCategory";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";

interface InfoAnimalDeathProps {
  task: ITaskAnimalResolver | undefined;
}


export default function InfoAnimalDeath(task: InfoAnimalDeathProps) {
  useTranslation();
  const [taskDeath, setTaskDeath] = useState<ITaskAnimalResolver>();
  useEffect(() => {
    setTaskDeath(task.task)
  }, []);

  return (
    <>
      <div>
        <span><Trans i18nKey="taskDetails.fromBatch" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskDeath?.batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      {taskDeath?.details.map((detail, detailIndex) => (
        <div key={detailIndex} className="containerQuestion">
          <MessageBalloon text={`${detail?.reason}`} />
          {detail.categories.map((category, catIndex) => (
            <div key={`${detailIndex}-${catIndex}`}>
              <div className="lot__title--category" style={{ marginTop: 0 }}>{translateAnimalCategory(category.category_description.name, category.category_description.age_description)}</div>
              <div className="lot__subtitle--category">{translateAnimalCategoryAge(category.category_description.age_description, category.category_description.name)}</div>
              <CounterInputV2 name={`info-animal-death-qty-${detailIndex}-${catIndex}`} value={Number(category.quantity ?? 0)} disabled />
            </div>
          ))}
        </div>
      ))}
    </>
  )
}
